/**
 * エラー表示の共通部品。
 *
 * セッション切れ（401）だけは「再試行」ではなく再ログインの導線を出す。
 * 自動リダイレクトはしない（AuthGate と同じ理由。原因が見えなくなるため）。
 */

import { api, ApiError } from '@app/api/client';

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return '不明なエラーが発生しました';
}

export function isUnauthorized(error: unknown): boolean {
  return error instanceof ApiError && error.isUnauthorized;
}

export interface ErrorNoticeProps {
  error: unknown;
  onRetry?: () => void;
}

export function ErrorNotice({ error, onRetry }: ErrorNoticeProps) {
  if (isUnauthorized(error)) {
    return (
      <div className="al-notice al-notice--danger notice-block" role="alert">
        <p>ログインの有効期限が切れました。</p>
        <a className="al-button al-button--primary" href={api.loginUrl()}>
          再ログイン
        </a>
      </div>
    );
  }
  return (
    <div className="al-notice al-notice--danger notice-block" role="alert">
      <p>{errorMessage(error)}</p>
      {onRetry && (
        <button type="button" className="al-button al-button--secondary" onClick={onRetry}>
          再試行
        </button>
      )}
    </div>
  );
}
